export default __webpack_public_path__ + "static/media/Mojito.96d7f2f6.flac";